import { render, staticRenderFns } from "./_infoHerbal.vue?vue&type=template&id=c2af361c"
import script from "./_infoHerbal.vue?vue&type=script&lang=js"
export * from "./_infoHerbal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports